import React from "react";

function PageTitle({ title, subtitle }: { title: string; subtitle: string }) {
  return (
    <div className="flex items-start flex-col">
      <span className="text-[#2A2E34] font-semibold text-2xl">{title}</span>
      <span className="text-primary-50 font-medium text-sm">{subtitle}</span>
    </div>
  );
}

export default PageTitle;
